/*
 * @Author: xiehangyi
 * @LastEditors: 黄昱森
 * @Description: 字典相关接口
 */
import { request } from '@/apis/request';
import dictStatic from './dict-static';
//应用数据字典 -- 查询应用字典列表
export function getDict(appId, params, hideLoading = true) {
  return request({
    url: `/v1/app/dict/${appId}/page`,
    method: 'get',
    params,
    hideLoading,
  });
}

//应用数据字典项 -- 查询应用字典项列表
export function getDictItem(appId, params, hideLoading = true) {
  return request({
    url: `/v1/app/dictItem/${appId}/page`,
    method: 'get',
    params,
    hideLoading,
  });
}

// 应用数据字典项 -- 将查询到的数据字典项结果，直接处理为组件需要的选项数据
export function getOptionsFromDict(dictCode = '', params = {
  keyPropName: 'key',
  labelPropName: 'label',
  valuePropName: 'value'
}) {
  const dict = dictStatic[dictCode] || [];
  return dict.map(item => ({
    [params.labelPropName]: item.label,
    [params.valuePropName]: item.value
  }));
}